import { STATUS_LABELS } from "@/lib/templates";

const STYLES = {
  new: {
    bg: "rgba(255, 255, 255, 0.05)",
    color: "#FFFFFF",
    border: "rgba(255, 255, 255, 0.2)",
  },
  emailed: {
    bg: "rgba(59, 130, 246, 0.1)",
    color: "#60A5FA",
    border: "rgba(59, 130, 246, 0.3)",
  },
  called: {
    bg: "rgba(168, 85, 247, 0.1)",
    color: "#C084FC",
    border: "rgba(168, 85, 247, 0.3)",
  },
  interested: {
    bg: "rgba(244, 184, 96, 0.1)",
    color: "#F4B860",
    border: "rgba(244, 184, 96, 0.3)",
  },
  call_booked: {
    bg: "rgba(20, 184, 166, 0.1)",
    color: "#5EEAD4",
    border: "rgba(20, 184, 166, 0.35)",
  },
  customizing: {
    bg: "rgba(249, 115, 22, 0.1)",
    color: "#FDBA74",
    border: "rgba(249, 115, 22, 0.3)",
  },
  closed_won: {
    bg: "rgba(34, 197, 94, 0.1)",
    color: "#4ADE80",
    border: "rgba(34, 197, 94, 0.3)",
  },
  dead: {
    bg: "rgba(239, 68, 68, 0.1)",
    color: "#F87171",
    border: "rgba(239, 68, 68, 0.3)",
  },
};

export function StatusPill({ status, className = "" }) {
  const s = STYLES[status] || STYLES.new;
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`inline-flex items-center rounded-sm px-2 py-0.5 text-[11px] font-medium tracking-wide uppercase border ${className}`}
      style={{
        backgroundColor: s.bg,
        color: s.color,
        borderColor: s.border,
      }}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}
